/**
 * Several utilities
 *
 * (c) 2017 Alexander Schenkel, Kaden und Partner AG
 */

/**
 * Loops over an array-like and executes callback for each item.
 *
 * @param Array/iterable iterable An array or array-like to loop over
 * @param Function callback The callback which is executed for each item: `callback(item, index)`
 */

import $ from 'jquery';

export function foreach(iterable, callback) {
    if (iterable && iterable.length > 0) {
        for (let i = 0; i < iterable.length; i++) {
            callback(iterable[i], i);
        }
    }
}

/**
 * Makes a unique array: returns a new array with only unique items in it.
 */
export function unique(arr) {
    return arr.reduce(function (prev, act) {
        if (prev.indexOf(act) < 0) {
            prev.push(act);
        }
        return prev;
    }, []);
}

/**
 * Adds or removes an element from/to an array, depending
 * if it was in the array or not (aka toggle):
 * - adds el if arr does NOT contain it
 * - removes el if arr DOES contain it
 *
 *   @param Array arr The array to look for the element
 *   @param Object The element to add/remove
 *   @return Array the modified array
 */
export function toggleElement(arr, el) {
    let index = arr.indexOf(el);
    if (index < 0) {
        arr.push(el);
    } else {
        arr.splice(index, 1);
    }
    return arr;
}

export function hasClass(ele, cls) {
    return $(ele).hasClass(cls);
}

export function addClass(ele, cls) {
    $(ele).addClass(cls);
}

export function removeClass(ele, cls) {
    $(ele).removeClass(cls);
}

export function toggleClass(ele, cls) {
    $(ele).toggleClass(cls);
}

/**
 * Creates an absolut url by adding the webroot variable
 * ( see basepage.html ) from window.GLOBALS.webroot
 */
export function makeUrl(relUrl) {
    if (relUrl && relUrl.length > 0 && relUrl[0] !== '/') {
        relUrl = '/' + relUrl;
    }
    return window.GLOBALS.webroot + relUrl;
}

export function hideReadSpeaker() {
    let rspkr = window.rspkr || null;
    rspkr?.ui?.getActivePlayer() && rspkr.ui.getActivePlayer().close();
}
